<template>
  <div class="lots-table-wrapper">
    <Block v-if="isLoading" />
    <DxDataGrid
      :dataSource="lots"
      :showBorders="true"
      ref="dataGrid"
      :scrolling="{ useNative: true }"
      :paging="{ enabled: false }"
      :column-auto-width="true"
      style="max-height: 600px"
    >
      <DxColumn cell-template="actions-template" />
      <template #actions-template="{ data }">
        <div class="row-actions d-flex justify-center align-center" >
          <Button 
            icon="mdi-eye" 
            size="small" 
            @click="$emit('row-selected', data.data)"
          >
          </Button>
        </div>
      </template>

      <DxColumn dataField="ID_RealStateLot" caption="ID de lote" />

      <DxColumn dataField="LotName" caption="Nombre de lote" />
      
      <DxColumn dataField="LotNumber" caption="Número de lote" />
      
      <DxColumn dataField="PolygonNumber" caption="Número de polígono" />
      
      <DxColumn 
        dataField="ID_BaseService" 
        caption="Servicio Base" 
        cell-template="base-service-template"
      />
      <template #base-service-template="{ data }">
        {{  getServiceName(data.data.ID_BaseService) }}
      </template>

      <DxColumn 
        dataField="ID_InterestService" 
        caption="Servicio Interés" 
        cell-template="interest-service-template"
      />
      <template #interest-service-template="{ data }">
        {{  getServiceName(data.data.ID_InterestService) }}
      </template>

      <DxColumn 
        dataField="ID_Customer" 
        caption="Cliente" 
        cell-template="customer-template"
      />
      <template #customer-template="{ data }">
        {{ getCustomerName(data.data.ID_Customer) }}
      </template>

    </DxDataGrid>
  </div>
</template>

<script>
import Block from '@/components/Block.vue';
import { DxDataGrid, DxColumn } from "devextreme-vue/data-grid";
import Button from '@/components/Button.vue';

export default {
  name: 'RealStateLotsTable',
  components: {
    Block,
    DxDataGrid,
    DxColumn,
    Button,
    // Alert,
  },
  props: {
    lots: {
      type: Array,
      required: false,
      default: () => [],
    },
    services: {
      type: Array,
      required: false,
      default: () => [],
    },
    customers: {
      type: Array,
      required: false,
      default: () => [],
    },
    sellers: {
      type: Array,
      required: false,
      default: () => [],
    },
    saleTypes: {
      type: Array,
      required: false,
      default: () => [],
    },
    reservationTypes: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
      alert: {
        type: 'success',
        show: false,
        header: '',
        body: '',
        onInputEvent: this.closeAlert,
        onActionEvent: this.closeAlert,
      },
    };
  },
   methods: {
    getServiceName(ID_Service) {
      const service = this.services.find(s => {
        return `${s.ID_Service}` === ID_Service;
      })

      return service 
        ? service.Name || service.NameService
        : ''
    },
    getCustomerName(ID_Customer) {
      const customer = this.customers.find(s => {
        return `${s.ID_Customer}` === ID_Customer
      })

      return customer 
        ? customer.BusinessName
        : ''
    },
    showAlert(title, message, type = 'success', onInputEvent, onActionEvent) {
      this.alert.type = type;
      this.alert.title = title;
      this.alert.message = message;
      this.alert.show = true;
      this.alert.onInputEvent = onInputEvent 
        ? onInputEvent
        : this.closeAlert;
      this.alert.onActionEvent = onActionEvent 
        ? onActionEvent
        : this.closeAlert;
      
    },
    closeAlert() {
      this.alert.show = false;
    },
  },
  mounted() {
  }
}
</script>
